import React from "react";
import { WifiOff, Wifi } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAppStatusStore } from "../store/useAppStatusStore";

/**
 * Sticky (not fixed) so it NEVER overlays and steals clicks.
 * Only renders when offline.
 */
export function OfflineBanner() {
  const isOnline = useAppStatusStore((s) => s.isOnline);

  if (isOnline) return null;

  return (
    <div className="sticky top-0 z-50 w-full border-b border-amber-200 bg-amber-50/95 backdrop-blur">
      <div className="mx-auto max-w-6xl px-4 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <WifiOff className="w-4 h-4 text-amber-700 shrink-0" />
          <p className="text-sm text-amber-900 truncate">
            You’re offline. Some actions may not work until your connection is back.
          </p>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <Button
            variant="outline"
            size="sm"
            className="rounded-full border-amber-300 bg-white"
            onClick={() => window.location.reload()}
            title="Retry"
          >
            <Wifi className="w-4 h-4 mr-2" />
            Retry
          </Button>
        </div>
      </div>
    </div>
  );
}
